import { ICreateRoomParams } from 'APP/model/mainCall/mainCallModel.types';
import { mainCallModel } from 'APP/model/model';

interface ICreateRoomResult {
  result: boolean;
  channelId?: string;
  link?: string;
}

export const createRoom = async (params: ICreateRoomParams): Promise<ICreateRoomResult> => {
  try {
    const response = await mainCallModel.createRoom(params);

    if (!response) {
      return {
        result: false,
      };
    }

    return {
      result: true,
      ...response,
    };
  } catch {
    return { result: false };
  }
};
